import { doRequest } from "utils/core";

const qandaAPI = {
  getQA: (params) => {
    const url = "api/qanda/index";
    return doRequest("get", url, { params });
  },
};

export default qandaAPI;
